module.exports = __webpack_public_path__ + "img/cover-redeem-bg.dbbebb1a.jpg";